import { useEffect } from 'react';
import { useModalStore } from '@/services/modalStore';

/**
 * Resetta lo stato delle modali all'ingresso della pagina.
 */
export function useResetModals() {
  const resetModals = useModalStore(s => s.resetModals);

  useEffect(() => {
    resetModals();
  }, [resetModals]);
}
